'use client';

import * as React from 'react';
import ReactDOM from 'react-dom';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { FocusableLink } from 'ui';
import { logoAtom } from '../../../_components/design-state';

export function SiteLogo() {
  const logo = useAtomValue(logoAtom);
  const t = useTranslations('Blog.Logo');
  ReactDOM.preload(logo, {
    as: 'image',
    fetchPriority: 'high',
  });
  return (
    <FocusableLink href="/" className="site-logo-link">
      <img alt={t('Alt')} className="logo" src={logo} />
    </FocusableLink>
  );
}
